import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import Button from '../../../components/Button.js';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import { ServiceRequestStore } from '../../../store';
import config from '../../../config';

const useStyles = makeStyles({
  root: {
    padding: '1rem',
    maxWidth: '45rem',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  text: {
    padding: '0.5rem 0',
    width: '100%',
    textAlign: 'center',
  }
});

const MatchIntro = ({dispatch, handleAnswer}) => {
  const classes = useStyles();

  const onClick = () => {
    handleAnswer('request_type', 'SERVICE_MATCH_REQUEST');
  };

  React.useEffect(() => {
    dispatch(ServiceRequestStore.reset());
  }, []);  // eslint-disable-line

  return (
    <div className={classes.root}>
      <AccessibilityNewIcon color="primary" style={{ fontSize: 80 }} />
      <Typography variant="h1" color="primary" className={classes.text}>
        Let&apos;s find the best service providers for you!
      </Typography>
      <Typography variant="h3" className={classes.text}>
        To find the best matches for you, we need to ask a few questions about you or the person you&apos;re enquiring on behalf of.
      </Typography>
      <Typography variant="h3" className={classes.text}>
        We only ask for information we need to find suitable matches.
      </Typography>
      <Typography variant="h3" className={classes.text}>
        We will share the information you provide with service providers who we think can best meet your needs.
      </Typography>
      <Typography variant="h3" className={classes.text}>
        If you need help, you can speak to our friendly team by calling <b>{config.phone}</b>.
      </Typography>
      <Typography variant="h3" className={classes.text}>
        All information you provide will be handled in accordance with our&nbsp;
        <Link component={RouterLink} to="/privacy">
          <b>Privacy Policy</b>
        </Link>
        , and by continuing, you agree to our&nbsp;
        <Link component={RouterLink} to="/terms">
          <b>Terms and Conditions</b>
        </Link>
        .
      </Typography>
      <Button
        onClick={onClick}
        label="Get started"
        pointer="right"
        variant="contained"
        style={{marginTop: '1.5rem'}}
      />
    </div>
  );
};

MatchIntro.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default MatchIntro;
